// 工单控件
import Title from './Title'
import TooltipText from './TooltipText'
import Radio from './Radio'
import Checkbox from './Checkbox'
import Input from './Input'
import Textarea from './Textarea'
import Select from './Select'
import DatePicker from './DatePicker'
import Upload from './Upload'
import Download from './Download'
import Divider from './Divider'
import InputNumber from './InputNumber'
import FormFlow from './FormFlow'
import Form from './Form'

export default {
  Title,
  TooltipText,
  Radio,
  Checkbox,
  Input,
  Textarea,
  Select,
  DatePicker,
  Upload,
  Download,
  Divider,
  InputNumber,
  FormFlow,
  Form
}
